import { EmptyState, PageSection } from "@client/components/ui";
import { basketsQuery } from "@client/lib/queries";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/koszyki/")({
  beforeLoad: async ({ context }) => {
    const baskets = await context.queryClient.ensureQueryData(basketsQuery());
    const first = baskets.find((b) => b.status !== "closed") ?? baskets[0];
    if (first) throw redirect({ to: "/koszyki/$basketId", params: { basketId: first.id } });
  },
  component: KoszykiIndexPage,
});

function KoszykiIndexPage() {
  return (
    <PageSection title="Koszyki">
      <EmptyState title="Brak koszyków" hint="Dodaj token do watchlisty i utwórz pierwszy koszyk." />
    </PageSection>
  );
}
